<template>
  <div>
    <FormWizardStepHeader title="Do you invest in impact startups?">
      These are startups that tackle societal problems within the SDGs.
    </FormWizardStepHeader>

    <div>
      <AlertSlideUpDown :show="$v.isImpact.$error && $v.isImpact.dirty"
        >Please select if you invest in impact startups</AlertSlideUpDown
      >

      <FormItem required>
        <b-form-radio-group
          v-model="form.isImpact"
          name="isImpact"
          buttons
          class="btn-group-outline-spaced-big mb-20"
          @input="$v.isImpact.$touch()"
        >
          <b-form-radio
            v-for="option in options"
            :key="option.value"
            v-model="isImpactCompany"
            :value="option.value"
            >{{ option.label }}</b-form-radio
          >
        </b-form-radio-group>
      </FormItem>

      <div v-if="form.isImpact" class="sdgs">
        <FormItem label="Select the specific SDGs below that you invest in">
          <div class="pb-10">
            <button class="btn btn-link" @click="selectAll">Select all</button>
          </div>

          <AlertSlideUpDown :show="$v.sdgs.$error && $v.sdgs.$dirty"
            >Please select at least one SDG</AlertSlideUpDown
          >

          <button
            v-for="(sdg, i) in sdgs"
            :key="i"
            :class="{
              'is-active': isActive(sdg)
            }"
            class="sdg"
            @click="toggle(sdg)"
          >
            <img
              :src="require(`@/assets/components/sdgs/inactive/${i + 1}.svg`)"
              class="inactive"
              alt="sdg inactive"
            />
            <img
              :src="require(`@/assets/components/sdgs/active/${i + 1}.svg`)"
              class="active"
              alt="sdg active"
            />
          </button>
        </FormItem>
      </div>

      <!-- TODO: Wait until we've released +impact MVP before releasing this into production 
    <FormItem label="List your startup automatically on +Impact?">
      <a
        href="https://plusimpact.io/"
        class="text-blue-900"
        target="_blank"
      >(Read more about +Impact)</a>
      <b-form-radio-group buttons class="btn-group-outline-spaced-big mb-20">
        <b-form-radio
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >{{ option.label }}</b-form-radio>
      </b-form-radio-group>
    </FormItem>
    --></div>
  </div>
</template>

<script>
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'
import FormItem from '@/components/form/FormItem'

export default {
  name: 'InvestorFormStepImpact',
  components: {
    AlertSlideUpDown,
    FormWizardStepHeader,
    FormItem
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      },
      isImpactCompany: undefined
    }
  },
  computed: {
    options() {
      return [
        {
          value: true,
          label: 'Yes'
        },
        {
          value: false,
          label: 'No'
        }
      ]
    },
    sdgs() {
      return this.$store.getters['meta/sdgs']
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    isImpactCompany(value) {
      if (value === false) {
        // reset SDGs if user clicks 'Yes' and then 'No'
        this.form.sdgs = []
      }
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  },
  methods: {
    isActive(sdg) {
      return (this.form.sdgs || []).indexOf(sdg.value) !== -1
    },
    toggle(sdg) {
      const index = (this.form.sdgs || []).indexOf(sdg.value)

      if (index === -1) {
        this.form.sdgs.push(sdg.value)
      } else {
        this.form.sdgs.splice(index, 1)
      }
    },
    selectAll() {
      if (this.form.sdgs.length !== this.sdgs.length) {
        this.form.sdgs = this.sdgs.map((item) => item.value)
      } else {
        this.form.sdgs = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sdgs {
  display: flex;
  flex-wrap: wrap;
  margin: -5px;

  .sdg {
    margin: 5px;
    position: relative;

    .active {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.3s;
    }

    &.is-active {
      .active {
        opacity: 1;
      }
    }
  }
}
</style>
